// tslint:disable

import { get } from 'lodash';
import * as moment from 'moment';
import * as React from 'react';
import { FormLib } from '../../components/libs/form.lib';
import { ResourceLoader } from '../../components/libs/resource-loader';
import { DefaultSave } from '../../components/libs/updaters/default-save';
import { LoaderComponent } from '../../components/structurals/loader.component';
import { IriPresenter } from '../../components/structurals/presenters/iri-presenter';
import { ToggleBoxComponent } from '../../components/structurals/toggle-box.component';
import {Notification} from "../../index";
import {Environment} from "../../environment/environment";
import axios from "axios";
import {SelectField} from "../../components/fields/select.field";
import {TextAreaField} from "../../components/fields/textarea.field";

export class AtasEnquiry extends React.Component<any, any> {
    private executor: DefaultSave<any> = new DefaultSave<any>(null, this.props);

    public async saveForm(form: FormLib): Promise<any> {
        this.executor.updateForm(form);
        await this.executor.exec();
    }

    render() {
        return (
            <ResourceLoader entity="enquiry" entityId={this.props.ENTITY_ID} render={(form: FormLib, raw: any) => <div>
                <LoaderComponent isLoading$={this.executor.loading$}/>
                <ToggleBoxComponent title="View Enquiry" color="green" alwaysOpen={true}>

                    <div className="row">
                        <div className="col-xs-12">

                            <SelectField
                                field={form.fields.processed}
                                options={[
                                    {value: 0, label: 'New'},
                                    {value: 1, label: 'Closed'},
                                    {value: 2, label: 'In Progress'},
                                    {value: 3, label: 'Not interested'},
                                    {value: 4, label: 'Follow up'},
                                ]}
                            />

                            <TextAreaField
                                field={form.fields.comment}
                            />

                            <b>Name:</b> <IriPresenter iri={get(form.fields.title.value, '@id',)} render={(title: any) => get(title, 'name')}/> {get(form.fields.name, 'value')}<br/>
                            <b>E-mail:</b> {get(form.fields.email, 'value')}<br/>
                            <b>Phone:</b> {get(form.fields.phone, 'value')}<br/>
                            <b>Company:</b> {get(form.fields.company, 'value')}<br/>
                            <b>Consortia:</b> {get(form.fields.consortia, 'value')}<br/>
                            <b>Date:</b> {moment(get(form.fields.createdAt, 'value')).format('DD/MM/Y H:mm')}<br/>
                            <br/>
                            <blockquote dangerouslySetInnerHTML={{__html: raw.message}}></blockquote>

                            <div className="divider"></div>

                        </div>
                        <div className="col-xs-12">
                            <button className="btn btn-primary pull-left" onClick={() => this.saveForm(form)}>Save</button>
                        </div>

                        <div className="divider"></div>
                        <div className="col-xs-12">
                            <a onClick={(event: any) => this.handleDelete(raw)} className="btn btn-warning pull-right" href="#">
                                Delete enquire
                            </a>
                        </div>
                    </div>
                </ToggleBoxComponent>
            </div>}/>
        );
    }

    private async handleDelete(item: any) {


        const answer = await Notification.delete();

        if (answer === true) {
            try {
                await axios.delete(`${Environment.get('api.base')}${item['@id']}`, {withCredentials: true});
                Notification.notify({
                    title: 'Delete is successful',
                    timer: 3000
                });

                window.location.href = '/enquiry';
            } catch (error) {
                Notification.error('Error', error.message);
                false;
            } finally {

            }
        }

    }
}



// WEBPACK FOOTER //
// ./src/__templates/details/atas.enquiry.tsx